import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// estilos
import './projects.css';
import '../../assets/style/componentPrincipal.css';

// componentes
import { ListMode } from './ListMode';
import { ModalProgress } from '../modals/ModalProgress';

import { iniLoadProject } from '../../redux/actions/project';

export const ProjectsList = () => {

    const dispatch = useDispatch()

    const { perfil } = useSelector(state => state.auth)
    const { list: projectList } = useSelector(state => state.project)

    const gridMode = false
    const loading = false

    useEffect(() => {

        const filters = {
            time: 'year',
            estado_validacion: '',
            text: '',
            fecha_desde: new Date(),
            fecha_hasta: new Date(),
            por_aprobar: true,
            anulado: false,
            id_ejecutivo: '',
            perfil: perfil,
            page: 1,
            rows: 10
        }

        dispatch(iniLoadProject(filters));
    }, [dispatch, perfil])

    return (
        <div className='container-fluid'>
            <h1 className='text-[#595759] text-[20px] mt-[15px] mb-[20px] font-semibold'>Proyectos</h1>
            <h5>
                <span className='text-[rgb(142,36,170)] text-[13px] bg-[#f1eaf3] p-1 rounded'>
                    <i className="bi bi-funnel"></i>
                    <span className='ms-1'>Todos en proceso</span>
                </span>
            </h5>

            {loading && <ModalProgress />}

            <div className='row mt-4 mb-[70px] animate__animated animate__fadeIn'>
                <div className={`col ${gridMode && 'd-flex flex-wrap justify-content-start'}`}>
                    {!gridMode && projectList?.map(p => (
                        <Link to={`/projects/${p.id}`} className='p-project-link'>
                            <ListMode
                                item={p}
                                key={p.id}
                            />
                        </Link>
                    ))
                    }
                </div>
            </div>

        </div >
    )
}